import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { GraphemeMnemonicsFlashcardSurface } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels";
import { LearnFlashcardSurfaceReadyMarker } from "@-/dev.improve.haniverse.routes.nav.app.learn.deck.context";
import { NewMorphemeLessonLayoutContext } from "@-/dev.improve.haniverse.routes.nav.app.learn.lesson.new-morpheme._context";

/** The lesson's mnemonics as a deck card face: meaning tab plus one tab per prevalent reading. */
export function LessonFlashcardBack() {
  const [grapheme, onlyPinyin] = useContextSelectors(
    NewMorphemeLessonLayoutContext,
    (c) => c.grapheme,
    (c) => c.onlyPinyin,
  );
  return (
    <>
      {/* A single-reading lesson (干 gan1) opens on the reading it introduces. */}
      <GraphemeMnemonicsFlashcardSurface initialPinyin={onlyPinyin} rawGrapheme={grapheme} />
      <LearnFlashcardSurfaceReadyMarker />
    </>
  );
}
